import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3l-.005 -.176a3 3 0 0 0 -.654 -1.7l-.106 -.124l.106 -.124a3 3 0 0 0 -2.341 -4.876m0 6a1 1 0 0 1 0 2h-1v-2zm0 -4a1 1 0 0 1 0 2h-1v-2z","key":"svg-0"}]]

const IconCircleLetterBFilled = createReactComponent('filled', 'circle-letter-b-filled', 'CircleLetterBFilled', __iconNode);

export default IconCircleLetterBFilled;